import React from "react";
import { useCommonContext } from "../../SignInSecurity/CommonProvider";
import {Alert, Typography} from "@one-thd/sui-atomic-components";


function StencilGlobalAlert() {
  const { alert, removeAlert } = useCommonContext();
  const { alertType, alertMessage, privacyLink } = alert || {};


  if(!alert) {
    return null
  }

  return (
      <Alert onClose={removeAlert} status={alertType}>
          <Typography>
              {alertMessage}
          </Typography>
          {privacyLink && (
              <Typography variant='body-xs'>
                  See our <a className="security-privacy-link" target="_blank" rel="noreferrer" href="https://www.homedepot.com/privacy/privacy-and-security-statement#HowDoWeUseInformation">Privacy & Security Statement</a> to learn more about how we use your information.
              </Typography>
          )}
      </Alert>
  )
}

export default StencilGlobalAlert;